import { render, staticRenderFns } from "./InvoiceReceipt.vue?vue&type=template&id=c27ce5c6&scoped=true&"
import script from "./InvoiceReceipt.vue?vue&type=script&lang=js&"
export * from "./InvoiceReceipt.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceReceipt.vue?vue&type=style&index=0&id=c27ce5c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c27ce5c6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VContainer,VFlex,VLayout})
